<app-progress-dots *ngIf="isLoading" [isLoading]="isLoading"></app-progress-dots>
<code *ngIf="!isLoading && !hasError">{{ pinCode }}</code>
<div *ngIf="!isLoading && hasError" class="message-box warn">Unable to decrypt PIN</div>